const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Publicaciones en Grupos",
    summary:
      "Programa y automatiza publicaciones en grupos de WhatsApp de forma masiva y programada. Envía mensajes de texto, imágenes, videos y audios a múltiples grupos con control de intervalos.",
  },
  sections: [
    {
      id: "programacion_grupos",
      title: "1. Programación y Difusión",
      description:
        "Configura envíos programados hacia múltiples grupos de WhatsApp simultáneamente.",
      items: [
        {
          id: "seleccion_grupos",
          title: "Grupos Destino",
          definition:
            "Selecciona los grupos donde eres administrador o participante para realizar las publicaciones.",
        },
        {
          id: "multimedia_ia",
          title: "Contenido y Fábrica IA",
          definition:
            "Adjunta archivos multimedia o genera imágenes y videos con Inteligencia Artificial directamente para tus publicaciones.",
        },
      ],
    },
    {
      id: "control_sincronizacion",
      title: "2. Sincronización y Monitoreo",
      description:
        "Actualiza la lista de grupos y supervisa el estado de tus envíos.",
      items: [
        {
          id: "sincronizar_grupos",
          title: "Sincronización de Grupos",
          definition:
            "Actualiza en tiempo real los grupos vinculados a tu conexión de WhatsApp y limpia grupos inactivos.",
        },
        {
          id: "historial_envios",
          title: "Historial de Publicaciones",
          definition:
            "Monitorea publicaciones enviadas, pendientes o fallidas con opción de reprogramación inmediata.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Group Broadcasts",
    summary:
      "Schedule and automate publications across WhatsApp groups with bulk sending capabilities. Broadcast text, images, videos, and voice notes with flexible timing controls.",
  },
  sections: [
    {
      id: "programacion_grupos",
      title: "1. Scheduling & Broadcasting",
      description:
        "Configure automated broadcasts to multiple WhatsApp groups simultaneously.",
      items: [
        {
          id: "seleccion_grupos",
          title: "Target Groups",
          definition:
            "Select target groups where you have sending permissions to broadcast announcements.",
        },
        {
          id: "multimedia_ia",
          title: "Media Content & AI Studio",
          definition:
            "Attach media files or generate visuals and videos using AI Content Factory directly for your posts.",
        },
      ],
    },
    {
      id: "control_sincronizacion",
      title: "2. Sync & Monitoring",
      description:
        "Refresh group lists and audit scheduled broadcast statuses.",
      items: [
        {
          id: "sincronizar_grupos",
          title: "Group Sync",
          definition:
            "Sync connected WhatsApp groups in real time and clean inactive records.",
        },
        {
          id: "historial_envios",
          title: "Broadcast History",
          definition:
            "Track completed, pending, or failed posts with quick reschedule options.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Publicações em Grupos",
    summary:
      "Agende e automatize postagens em grupos do WhatsApp de forma unificada. Envie mensagens de texto, imagens, vídeos e áudios com agendamento flexível.",
  },
  sections: [
    {
      id: "programacion_grupos",
      title: "1. Agendamento e Disparos",
      description:
        "Configure envios programados para vários grupos do WhatsApp simultaneamente.",
      items: [
        {
          id: "seleccion_grupos",
          title: "Grupos de Destino",
          definition:
            "Escolha os grupos onde você possui permissão de envio para disparar comunicados.",
        },
        {
          id: "multimedia_ia",
          title: "Mídias e Fábrica de IA",
          definition:
            "Anexe arquivos ou produza imagens e vídeos profissionais com Inteligência Artificial para seus posts.",
        },
      ],
    },
    {
      id: "control_sincronizacion",
      title: "2. Sincronização e Monitoramento",
      description:
        "Mantenha sua lista de grupos atualizada e acompanhe o status dos envios.",
      items: [
        {
          id: "sincronizar_grupos",
          title: "Sincronização de Grupos",
          definition:
            "Atualize em tempo real os grupos conectados à sua sessão do WhatsApp.",
        },
        {
          id: "historial_envios",
          title: "Histórico de Publicações",
          definition:
            "Acompanhe postagens enviadas, agendadas ou com falhas para republicação ágil.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Diffusions dans les Groupes",
    summary:
      "Planifiez et automatisez des publications dans les groupes WhatsApp. Diffusez des textes, images, vidéos et notes vocales avec planification horaire précise.",
  },
  sections: [
    {
      id: "programacion_grupos",
      title: "1. Planification et Diffusion",
      description:
        "Configurez des envois automatiques vers plusieurs groupes WhatsApp simultanément.",
      items: [
        {
          id: "seleccion_grupos",
          title: "Groupes Cibles",
          definition:
            "Sélectionnez les groupes où vous pouvez publier des annonces.",
        },
        {
          id: "multimedia_ia",
          title: "Médias et Studio IA",
          definition:
            "Joignez des médias ou générez des images et vidéos personnalisées avec l'IA.",
        },
      ],
    },
    {
      id: "control_sincronizacion",
      title: "2. Synchronisation et Suivi",
      description:
        "Actualisez vos groupes et surveillez l'état d'envoi de vos publications.",
      items: [
        {
          id: "sincronizar_grupos",
          title: "Synchronisation des Groupes",
          definition:
            "Synchronisez les groupes connectés à votre compte WhatsApp en temps réel.",
        },
        {
          id: "historial_envios",
          title: "Historique des Diffusions",
          definition:
            "Suivez les diffusions envoyées ou en attente avec réédition immédiate.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "النشر في مجموعات واتساب",
    summary:
      "جدولة وأتمتة النشر عبر مجموعات واتساب بشكل جماعي ومركزي. أرسل النصوص والصور ومقاطع الفيديو والتسجيلات الصوتية بمرونة تامة.",
  },
  sections: [
    {
      id: "programacion_grupos",
      title: "1. الجدولة والبث",
      description:
        "إعداد منشورات مجدولة للإرسال إلى مجموعات واتساب متعددة في وقت واحد.",
      items: [
        {
          id: "seleccion_grupos",
          title: "المجموعات المستهدفة",
          definition:
            "اختر المجموعات التي تشارك فيها لنشر التحديثات والإعلانات.",
        },
        {
          id: "multimedia_ia",
          title: "الوسائط واستوديو الذكاء الاصطناعي",
          definition:
            "أرفق الملفات أو ولّد تصاميم وفيديوهات احترافية باستخدام الذكاء الاصطناعي.",
        },
      ],
    },
    {
      id: "control_sincronizacion",
      title: "2. المزامنة والمراقبة",
      description:
        "تحديث قائمة المجموعات والتحقق من حالة المنشورات المجدولة.",
      items: [
        {
          id: "sincronizar_grupos",
          title: "مزامنة المجموعات",
          definition:
            "تحديث مجموعات واتساب المتصلة مباشرة وحذف المجموعات غير النشطة.",
        },
        {
          id: "historial_envios",
          title: "سجل المنشورات",
          definition:
            "متابعة المنشورات المنفذة والمعلقة مع إمكانية التعديل السريع.",
        },
      ],
    },
  ],
};

export const GROUP_HELP_DATA = { es, en, pt, fr, ar };
export default GROUP_HELP_DATA;
